import moment from 'moment-timezone';

export const dateToUtcDate = (date: Date) => {
  return moment.tz(moment(date).format('YYYY-MM-DD HH:mm:ss'), 'Asia/Seoul').utc().toDate();
};

export const isValidDateString = (value: string) => {
  try {
    const date = new Date(value);
    if (!date.getTime()) {
      return false;
    }
    return true;
  } catch {
    /* empty */
  }
  return false;
};

export interface ConvertDateTimeOptions {
  timeToZero?: boolean;
}

export const localTimeToUtcISOString = (datetime: Date | string | null, options?: ConvertDateTimeOptions) => {
  if (!datetime) {
    return null;
  }

  if (options?.timeToZero) {
    // 명시적으로 Asia/Seoul 시간대로 파싱하여 UTC로 변환
    if (typeof datetime === 'string') {
      return moment
        .tz(datetime + ' 00:00:00', 'Asia/Seoul')
        .utc()
        .toISOString();
    }
    return moment.tz(datetime, 'Asia/Seoul').set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).utc().toISOString();
  }

  // 명시적으로 Asia/Seoul 시간대로 파싱하여 UTC로 변환
  return moment.tz(datetime, 'Asia/Seoul').utc().toISOString();
};
